import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    DialogTitle,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useAuthStore } from "../../stores/authStore";
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";

interface IModalTundaTokoProps {
    closeModalTundaToko: () => void;
    isOpenModalTundaToko: boolean;
}

const ModalTundaToko = ({
    closeModalTundaToko,
    isOpenModalTundaToko,
}: IModalTundaTokoProps) => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const logout = useAuthStore((s) => s.logout);
    const isLoading = useAuthStore((s) => s.isLoading);

    const handleKeluar = () => {
        logout();
        closeModalTundaToko();
    };

    return (
        <>
            <Dialog
                maxWidth="xs"
                fullWidth={true}
                fullScreen={isPhoneScreen}
                open={isOpenModalTundaToko}
                onClose={closeModalTundaToko}
                PaperProps={{
                    sx: {
                        //   minHeight: "150px",
                        //   maxHeight: "150px",
                        borderRadius: 1,
                    },
                }}
            >
                <DialogTitle>Tunda pembuatan ukm?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Anda yakin ingin menunda pembuatan ukm dan keluar dari
                        sistem?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ padding: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={handleKeluar}
                        color="error"
                        sx={{
                            fontWeight: "bold",
                        }}
                    >
                        Ya, Tunda
                    </Button>
                    <Button
                        variant="contained"
                        onClick={closeModalTundaToko}
                        color="error"
                        sx={{
                            fontWeight: "bold",
                        }}
                    >
                        Tidak
                    </Button>
                </DialogActions>
            </Dialog>
            <LoadingOverlay open={isLoading} />
        </>
    );
};

export default ModalTundaToko;
